<template>
  <div class="set-dialog__body">
    <el-dialog
      :class="{'dialog-full-min': !isErrorTip}"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      @open="handleOpen"
      width="50%"
    >
      <div slot="title" class="flex flex-align-center">
        <div v-if="isErrorTip" class="header-title">确认收款提示</div>
        <template v-else>
          <i class="el-icon-warning" />
          <div class="margin-left-16">{{textConfig.title}}</div>
        </template>
      </div>
      <div class="dialog__body">
        <div v-if="isErrorTip">
          <receipt-tip-table :table-data="tableData" />
        </div>
        <div v-else class="dialog__body-text">{{textConfig.messageTip}}</div>
      </div>
      <span
        v-if="isErrorTip"
        slot="footer"
        class="flex flex-align-center flex-justify-center"
      >
        <el-button @click="handleCloseTip()" :size="formSize">关闭</el-button>
      </span>
      <span
        v-else
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose()" :size="formSize">取消</el-button>
        <el-button
          type="primary"
          :size="formSize"
          @click="submit()"
          :loading="loading"
        >
          确认
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { setReceiptOper } from '@/api/receivables/receipt';
import receiptTipTable from './receipt-tip-table';

export default {
  components: { receiptTipTable },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    receiptObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    textConfig: {
      type: Object,
      default: () => {
        return {
          title: '人工确认',
          messageTip: '是否人工确认该笔收款单？',
        };
      },
    },
  },
  data() {
    return {
      isErrorTip: false, // 是否确认失败
      tableData: [], // 确认失败应收单数据
      loading: false,
    };
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
    },
    // 关闭收款确认提示
    handleCloseTip() {
      this.handleClose();
      this.$emit('success');
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.isErrorTip = false;
        this.loading = false;
      });
    },
    // 提交
    submit() {
      this.setReceiptOper(this.receiptObj);
    },
    // 收款单确认/作废请求接口
    async setReceiptOper(params) {
      try {
        this.loading = true;
        const res = await setReceiptOper(params);
        if ([1, '1'].includes(res.data.status)) {
          this.$message({
            message: '操作成功！',
            type: 'success',
          });
          this.loading = false;
          this.handleClose();
          this.$emit('success');
        } else {
          this.tableData = res.data?.receiveList || [];
          this.isErrorTip = true;
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.isErrorTip = false;
        this.loading = false;
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.set-dialog__body {
  ::v-deep {
    .el-button {
      min-width: 64px;
      padding: 8px 16px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
  .dialog__body {
    &-text {
      margin-left: 42px;
    }
  }
}
.header-title {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}
</style>
